<template>
  <div id="distributors">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <!-- Edit Modal -->
        <CModal
          title="Editar Distribuidor"
          :show.sync="editModal.show"
          :centered="true"
        >
          <CRow>
            <CCol col="12">
              <div class="form-group">
                <CInput
                  v-model="editForm.nome_fantasia"
                  label="Nome Fantasia"
                  :is-valid="formErrors.nome_fantasia"
                  invalid-feedback="Informe o nome fantasia"
                  required
                />
              </div>
            </CCol>
            <CCol col="12">
              <div class="form-group">
                <CInput
                  v-model="editForm.cidade"
                  label="Cidade"
                  :is-valid="formErrors.cidade"
                  invalid-feedback="Informe a cidade"
                  required
                />
              </div>
            </CCol>
            <CCol col="12">
              <div class="form-group">
                <CInput
                  v-model="editForm.estado"
                  label="UF"
                  :is-valid="formErrors.estado"
                  invalid-feedback="Informe a UF com 2 letras"
                  maxlength="2"
                  required
                />
              </div>
            </CCol>
            <CCol col="12">
              <div class="form-group">
                <CInput
                  v-model="editForm.telefone"
                  label="Telefone"
                  :is-valid="formErrors.telefone"
                  invalid-feedback="Informe um telefone válido"
                />
              </div>
            </CCol>
            <CCol col="12">
              <div class="form-group">
                <CSelect
                  :value.sync="editForm.status"
                  :options="statusOptions"
                  label="label"
                  placeholder="Status"
                />
              </div>
            </CCol>
          </CRow>
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="processing"
              @click="toggleEditModal"
            >
              Cancelar
            </button>
            <CButton
              color="success"
              :disabled="processing"
              @click="saveEdit"
            >
              Salvar
            </CButton>
          </template>
        </CModal>
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center py-3">
            <h4 class="mb-0">
              Distribuidores
            </h4>
          </CCardHeader>
          <CCardBody>
            <!-- Search -->
            <CRow>
              <CCol col="12">
                <Search @search="updateSearch" />
              </CCol>
            </CRow>

            <!-- Datatable -->
            <CRow>
              <CCol col="12">
                <DataTable
                  :sorter="query.sorter"
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-export="false"
                  :enable-switch-status="false"
                  base-route=""
                  @sorterValue="(event) => (query.sorter = event)"
                  @row-clicked="handleRowClick"
                >
                  <template #actions="{ item }">
                    <a
                      href="javascript:void(0)"
                      @click="openEdit(item)"
                    >
                      <CIcon
                        v-c-tooltip="'Editar'"
                        name="cil-pencil"
                        placement="top"
                      />
                    </a>
                  </template>
                </DataTable>
              </CCol>
            </CRow>

            <!-- Pagination -->
            <CRow class="mt-2">
              <CCol lg="12">
                <Pagination
                  :page="query.page"
                  :per-page="query.perpage"
                  :pages="pagination.pages"
                  :total="pagination.total"
                  :items="pagination.items"
                  @update:active-page="(page) => (query.page = page)"
                  @update:perpage="(perpage) => (query.perpage = perpage)"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// Components
import DataTable from '@/components/ui/Datatable'
import Pagination from '@/components/ui/Pagination'
import Search from '@/components/ui/Search'

// Services
import Service from '@/services/distributors.service'

export default {
  metaInfo: {
    title: 'Distribuidores',
    titleTemplate: ' %s - Manager - Intelli'
  },

  components: {
    DataTable,
    Pagination,
    Search
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'codigo',
            label: 'Código',
            _style: 'width: 10%',
            sorter: true
          },
          {
            key: 'nome_fantasia',
            label: 'Nome Fantasia',
            _style: 'width: 30%;',
            sorter: true
          },
          {
            key: 'cidade',
            label: 'Cidade',
            sorter: true
          },
          {
            key: 'estado',
            label: 'UF',
            sorter: true
          },
          {
            key: 'telefone',
            label: 'Telefone',
            sorter: false
          },
          {
            key: 'status',
            label: 'Status',
            sorter: false
          },
          {
            key: 'actions',
            label: 'Ações',
            sorter: false,
            _style: 'width: 12%; min-width: 0px'
          }
        ]
      },
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        pagination: true,
        sorter: {
          asc: false,
          column: ''
        }
      },
      pagination: {
        total: 0,
        pages: 0,
        items: 0
      },
      rowCliked: {},
      statusOptions: [
        { label: 'Ativo', value: 'Ativo' },
        { label: 'Inativo', value: 'Inativo' }
      ],
      editModal: {
        show: false
      },
      editForm: {
        codigo: null,
        nome_fantasia: '',
        cidade: '',
        estado: '',
        telefone: '',
        status: 'Ativo'
      },
      formErrors: {
        nome_fantasia: null,
        cidade: null,
        estado: null,
        telefone: null
      },
      processing: false,
      isLoading: false
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    }
  },

  async created() {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable() {
      this.isLoading = true
      const response = await Service.index(this.query)
      const { data, pagination } = response

      if (data) {
        // Ordenação simples no cliente
        let newItems = data.map((item) => ({
          ...item,
          status: item.status === 1 || item.status === true ? 'Ativo' : 'Inativo'
        }))

        if (this.query.sorter && this.query.sorter.column) {
          const { column, asc } = this.query.sorter
          newItems = newItems.sort((a, b) => {
            const av = a[column]
            const bv = b[column]
            if (av == null && bv == null) return 0
            if (av == null) return asc ? -1 : 1
            if (bv == null) return asc ? 1 : -1
            if (typeof av === 'number' && typeof bv === 'number') {
              return asc ? av - bv : bv - av
            }
            return asc
              ? String(av).localeCompare(String(bv))
              : String(bv).localeCompare(String(av))
          })
        }

        if (pagination) {
          this.pagination = {
            ...pagination,
            pages: pagination.lastPage,
            items: data.length
          }
          this.datatable.items = newItems
        } else {
          const total = response.total || newItems.length
          const perpage = this.query.perpage
          const pages = Math.ceil(total / perpage)
          const isServerPaginated = response.total !== undefined && response.total !== newItems.length

          if (isServerPaginated) {
            this.pagination = {
              total,
              pages,
              items: newItems.length
            }
            this.datatable.items = newItems
          } else {
            const startIndex = (this.query.page - 1) * perpage
            const endIndex = startIndex + perpage
            this.pagination = {
              total,
              pages,
              items: Math.min(perpage, newItems.length - startIndex)
            }
            this.datatable.items = newItems.slice(startIndex, endIndex)
          }
        }
      }
      this.isLoading = false
    },

    async updateSearch(searchText) {
      this.query.search = searchText
      this.query.page = 1
      await this.updateDataTable()
    },

    handleRowClick(event) {
      this.rowCliked = event
    },

    openEdit(item) {
      // Preenche o formulário com o item selecionado
      this.editForm = {
        codigo: item.codigo,
        nome_fantasia: item.nome_fantasia || '',
        cidade: item.cidade || '',
        estado: item.estado || '',
        telefone: item.telefone || '',
        status: item.status || 'Ativo'
      }
      this.resetErrors()
      this.toggleEditModal(true)
    },

    toggleEditModal(force = null) {
      this.editModal.show = force !== null ? force : !this.editModal.show
    },

    resetErrors() {
      this.formErrors = {
        nome_fantasia: null,
        cidade: null,
        estado: null,
        telefone: null
      }
    },

    validateForm() {
      this.resetErrors()
      let valid = true
      if (!this.editForm.nome_fantasia) {
        this.formErrors.nome_fantasia = false
        valid = false
      }
      if (!this.editForm.cidade) {
        this.formErrors.cidade = false
        valid = false
      }
      if (!this.editForm.estado || String(this.editForm.estado).length !== 2) {
        this.formErrors.estado = false
        valid = false
      }
      return valid
    },

    async saveEdit() {
      if (!this.validateForm()) return
      this.processing = true
      const payload = {
        nome_fantasia: this.editForm.nome_fantasia,
        cidade: this.editForm.cidade,
        estado: this.editForm.estado,
        telefone: this.editForm.telefone,
        status: this.editForm.status === 'Ativo'
      }
      const response = await Service.update(this.editForm.codigo, payload)
      if (response && response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'Distribuidor atualizado com sucesso'
        })
        this.toggleEditModal(false)
        await this.updateDataTable()
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Ocorreu um erro ao atualizar o distribuidor, tente novamente'
        })
      }
      this.processing = false
    }
  }
}
</script>

<style lang="scss">
</style>
